import React from 'react';
import {connect} from 'react-redux';
import * as asyncStateAction from '../actions/asyncStateAction';
import * as commonStateAction from '../actions/commonStateAction';
import Header from '../mainpage/header';
import HealthWarning from '../mainpage/healthWarning';
import Loading from '../utils/animation/loading';
import {IReducerState} from '../states/renditionStates';
import servicesConfig from '../services/servicesConfig';
import _ from 'lodash';
import $ from 'jquery';
import RightPartTemplate from '../sidepart/rightPartTemplate';
import * as environmentService from '../utils/general/environmentService';
import LeftMenuPartTemplate from '../sidepart/leftMenuPartTemplate';
import {RenditionLoadable} from '../utils/general/LoadableRelated';
import {enterKeyPressed} from '../utils/general/enterKey';
import '../../style/symbols/symbols.scss';
import {
    executeForCV,
    isPresentation,
    shouldShowSearch,
    isAppInsideIFrame,
    isTabletOrPhone,
    isAndroidTabletOrPhone,
    isIOSTabletOrPhone,
    isHTMLLightRendition,
    isStaticMode,
    isStaticHtmlMode,
    isAppInsideCVResearchUIiFrame,
} from '../utils/general/general';
import MainPageCopyText from '../mainpage/mainPageCopyText';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import commonStore from '../../js/store/commonStore.js';
import HtmlPdfTogglePanel from './innerPagePart/htmlPdfTogglePanel';
import HtmlPdfToggleBar from './innerPagePart/htmlPdfToggleBar';
import * as HTML_RENDITION from '../utils/general/general';

// Important!!! Add react-loadable here,
// we can use react-loadable package diff productType code and dynamic load them.
// we need to use the loadable here rather than by using import method to avoid css overrides
const InnerPageContainer = RenditionLoadable({
    loader: () => import('./innerPageContainer'),
}, "innerPageContainer", Date.now());


const productType = window.HTML_RENDITION.initialData?.productType;
const productCode = window.HTML_RENDITION.initialData?.productCode?.toLowerCase();
const themeFromURL = "";
// _.get(
//     _.get(_.get(window, "location.href", "").split("?"), "[1]", "").split("="),
//       "[1]",
//       ""
// );
const showOldBranding = themeFromURL === "" ? (_.includes(["globalinsights","gps"],productType) ||
    window.HTML_RENDITION.initialData.enable2023rebranding === 'false') : themeFromURL === "old" ? true : false;

const docFileType = window.HTML_RENDITION.initialData.docFileType;
const templateCode = window.HTML_RENDITION.initialData.templateCode?.toLowerCase();
let container:any = null;

if (((productType === "company") || (productType === "industry") || (productType === "anr")) && (productCode !== "podcast")) {
    const LoadableMain = RenditionLoadable({
        loader: () => import('../entryPoint/mainPage'),
    }, "mainPage", Date.now());
    container = (
        <LoadableMain showOldBranding={showOldBranding}/>
    );
} else if ((productType === 'ppt' || productType === 'landscape' || docFileType === 'PPT')) { // PPT and Landscape
    const LoadablePresentation = RenditionLoadable({
        loader: () => import('../entryPoint/presentationMainPage'),
    }, "presentationMainPage", Date.now());
    container = (
        <LoadablePresentation showOldBranding={showOldBranding}/>
    );
} else if (window.HTML_RENDITION.isMCN) {
    window.HTML_RENDITION.isWordRender = true;
    const LoadableMultiCompany = RenditionLoadable({
        loader: () => import('../entryPoint/multicompanyMainPage'),
    }, "multicompanyMainPage", Date.now());
    container = (
        <LoadableMultiCompany showOldBranding={showOldBranding}/>
    );
} else if (window.HTML_RENDITION.isRoundup) {
    window.HTML_RENDITION.isWordRender = true;
    const LoadableRoundup = RenditionLoadable({
        loader: () => import('../entryPoint/roundupMainPage'),
    }, "roundupMainPage", Date.now());
    container = (
        <LoadableRoundup showOldBranding={showOldBranding}/>
    );
} else if (window.HTML_RENDITION.isGlobalizer) {
     window.HTML_RENDITION.isWordRender = true;
     const LoadablePage = RenditionLoadable({
         loader: () => import('../entryPoint/v2GlobaliserMainPage'),
     }, "v2GlobaliserMainPage", Date.now());
     container = (
         <LoadablePage showOldBranding={showOldBranding}/>
     );
 } else if (productType === 'audio' || productType === 'video') { // audio and video
    const LoadableMedia = RenditionLoadable({
        loader: () => import('../entryPoint/mediaMainPage'),
    }, "mediaMainPage", Date.now());
    container = (
        <LoadableMedia showOldBranding={showOldBranding}/>
    );
} else if (productType === "globaliser") {
    const LoadableGlobaliser = RenditionLoadable({
        loader: () => import('../entryPoint/globaliserMainPage'),
    }, "globaliserMainPage", Date.now());
    container = (
        <LoadableGlobaliser showOldBranding={showOldBranding}/>
    );
} else if (window.HTML_RENDITION.isPoint) {
    window.HTML_RENDITION.isWordRender = true;
    const LoadablePoint = RenditionLoadable({
        loader: () => import('../entryPoint/pointMainPage'),
    }, "pointMainPage", Date.now());
    container = (
        <LoadablePoint showOldBranding={showOldBranding}/>
    );
} else if (productType === "credit") {
    const LoadableCredit = RenditionLoadable({
        loader: () => import('../entryPoint/creditMainPage'),
    }, "creditMainPage", Date.now());
    container = (
        <LoadableCredit showOldBranding={showOldBranding}/>
    );
} else if (productType === "globalinsights") {
    if (templateCode === 'note' || templateCode === 'audio' || templateCode === 'video') {
        window.HTML_RENDITION.isHTMLRender = true;
        const LoadableGlobalInsights = RenditionLoadable({
            loader: () => import('../entryPoint/globalInsightsMainPage'),
        }, "globalInsightsMainPage", Date.now());
        container = (
            <LoadableGlobalInsights showOldBranding={showOldBranding}/>
        );
    }
} else if (productType === "gps") {
     if (templateCode === 'audio' || templateCode === 'video') {
         const LoadableGPS = RenditionLoadable({
             loader: () => import('../entryPoint/gpsMainPage'),
         }, "gpsMainPage", Date.now());
         container = (
             <LoadableGPS showOldBranding={showOldBranding}/>
         );
     }
} else if (productType === "nonrschreplay" || productCode === "podcast") {
    if (templateCode === 'audio' || templateCode === 'video') {
        window.HTML_RENDITION.isHTMLRender = true;
        const LoadableMainPage = RenditionLoadable({
            loader: () => import('../entryPoint/NonRSCHReplayMainPage'),
        }, "NonRSCHReplayMainPage", Date.now());
        container = (
            <LoadableMainPage showOldBranding={showOldBranding}/>
        );
    }
} else if (window.HTML_RENDITION.isOffCuffList && !isStaticHtmlMode()) {
    const LoadableOffCuffListMain = RenditionLoadable({
        loader: () => import('../entryPoint/offCuffListMainPage'),
    }, "offCuffListMainPage", Date.now());
    container = <LoadableOffCuffListMain showOldBranding={showOldBranding}/>;
} else if (
    window.HTML_RENDITION.isOffCuffContent ||
    (productType === "blog" && (window.HTML_RENDITION.initialData.mode == 'preview_mode' || isStaticHtmlMode()))) {
    window.HTML_RENDITION.isHTMLRender = true;
    const LoadableOffTheCuffSinglePostPage = RenditionLoadable({
        loader: () => import('../entryPoint/offTheCuffSinglePostPage'),
    }, "offTheCuffSinglePostPage", Date.now());
    container = <LoadableOffTheCuffSinglePostPage showOldBranding={showOldBranding}/>;
} else if (templateCode === 'citiexpress') {
    window.HTML_RENDITION.isHTMLRender = true;
    const LoadableCitiExpressMainPage = RenditionLoadable({
        loader: () => import('../entryPoint/citiExpressMainPage'),
    }, "citiExpressMainPage", Date.now());
    container = (
        <LoadableCitiExpressMainPage showOldBranding={showOldBranding}/>
    );
}  else if (docFileType == "HTML") {
    window.HTML_RENDITION.isHTMLRender = true;
    const LoadableFaveHTMLMain = RenditionLoadable({
        loader: () => import('../entryPoint/faveHTMLMainPage'),
    }, "faveHTMLMainPage", Date.now());
    container = (
        <LoadableFaveHTMLMain showOldBranding={showOldBranding}/>
    );
} else if (docFileType == "MSWORD") {
    window.HTML_RENDITION.isWordRender = true;
    const LoadableFaveMSWordMain = RenditionLoadable({
        loader: () => import('../entryPoint/faveMSWordMainPage'),
    }, "faveMSWordMainPage", Date.now());
    container = (
        <LoadableFaveMSWordMain showOldBranding={showOldBranding}/>
    );
}

interface IOverviewProps {
    loadInitialData: () => {};
    loadHeaderJsonData: () => {};
    sessionContextData: () => {};
    loadPlatformIdData: () => {};
    loadExcludeCopyFigurePlatformIdData: () => {};
    loadFooterJsonData: () => {};
    getScreenType: () => {};
    getMenuCode: () => {};
    loadFigureGalleryData: () => {};
    loadBodyJsonData: () => {};
    loadAnalystSubscriptionData: () => {};
    catalystWatchData?: any;
    docHeaderJsonData: any;
    initialData: any;
    docFooterJsonData: any;
    ifRequireDataGet: number;
    RequestSend: boolean;
    offTheCuffTitle: string;
    showOldBranding: boolean;
    analystSubscriptionData: any;
}
interface IOverviewStatus {
    showLeftFloatPanel: boolean;
  }

export class OverviewContainer extends React.Component<IOverviewProps, IOverviewStatus> {
    public oneTimeFlag: boolean;

    constructor(props: IOverviewProps) {
        super(props);
        this.oneTimeFlag = true;
        this.state = {
          showLeftFloatPanel: true
        };
        
        this.props.loadExcludeCopyFigurePlatformIdData();
        // If it is static html, we don't need to fetch json data again and just reuse preloaded state
        if (window.HTML_RENDITION.initialData.isStaticHtml) return;
        // Fetch json data by ajax
        this.props.loadPlatformIdData();
        this.props.loadInitialData();
        this.props.loadHeaderJsonData();
        this.props.getScreenType();
        this.props.loadAnalystSubscriptionData();
        this.props.getMenuCode();
        if (!window.HTML_RENDITION.initialData.isStaticHtmlExport) {
            this.props.sessionContextData();
        }
        // If it is offCuffList we don't need to fetch body json and footerjson and figureGalleryData
        if (!window.HTML_RENDITION.isOffCuffList) {
            window.HTML_RENDITION.initialData.docFileType == 'HTML' && this.props.loadBodyJsonData();
            window.HTML_RENDITION.initialData.docFileType !== 'HTML' && this.props.loadFooterJsonData();
            this.props.loadFigureGalleryData();
        }
    }

    public componentDidMount() {
        this.scrollEvent();
        executeForCV();
        // setTimeout(() => {
        //     $('.skip-to-main-content').css('display', 'block');
        // }, 1000);
        if (window.HTML_RENDITION.initialData.isStaticHtmlExport){
            this.exportStaticHTML();
        }
        if (window.HTML_RENDITION.isBlogPrintMode){
            this.printHTML();
        }
    }

    public printHTML() {
        const notifyPrint = function (){
            setTimeout(function (){
                const $fpC = $('.blog-fp-disclosure-container');
                const pdfPageHeight = 1270; // 979;//
                const fpDisclosureHeight = $fpC.height() || 0;
                const $divList = $('.wp-block-research-abstract-free-text-wrapper > div:not(.blog-fp-disclosure-container)');
                const size = $divList.length;
                let validIndex = 0;
                console.info('fpDisclosureHeight', fpDisclosureHeight);
                for (let i = 0; i < size; i++){
                    const itemTop = $divList.eq(i).cvOffSet().top;
                    const itemHeight = $divList.eq(i).height() || 0;
                    const currentHeight = fpDisclosureHeight + itemTop + itemHeight;
                    console.info('currentHeight #' + i, currentHeight);
                    if (currentHeight > pdfPageHeight){
                        validIndex = i - 1;
                        break;
                    } else {
                        validIndex = i;
                    }
                }
                if (validIndex < 0){
                    validIndex = 0;
                }
                $divList.eq(validIndex).after($fpC.css('display', 'block'));
                const fpTop = $fpC.cvOffSet().top;
                if (fpTop + fpDisclosureHeight < pdfPageHeight){
                    $('html.print > head').append($('<style>').html('@media print {.blog-fp-disclosure-container{margin-top: ' + (pdfPageHeight - (fpTop + fpDisclosureHeight + 5)) + 'px}}'));
                }
                window.print();
            }, 1000);
        };
        if (window.HTML_RENDITION.isHTMLRender){
            const maxWaitInMs = 200000;
            const checkDurationInMs = 1 * 1000;
            let currentWaitInMs = 0;
            const intervalId = setInterval(() => {
                let renderComplete = window.HTML_RENDITION.htmlRenderComplete;
                const imageLoadStatus : Array<string> = [];
                if (window.HTML_RENDITION.htmlRenderComplete && !window.HTML_RENDITION.bindImageLoadEvent){
                    const $img = $('img');
                    for (let i = 0; i < $img.length; i++){
                        imageLoadStatus[i] = 'loading';
                        $img.eq(i).one('load', function () {
                            imageLoadStatus[i] = 'loaded';
                            console.info('Image #' + i, imageLoadStatus[i]);
                        }).each(function () {
                            const el = this as HTMLImageElement;
                            if (el.complete) {
                                $(this).trigger('load');
                            }
                        });
                    }
                    window.HTML_RENDITION.bindImageLoadEvent = true;
                }
                if (window.HTML_RENDITION.bindImageLoadEvent){
                    renderComplete = renderComplete && _.indexOf(imageLoadStatus, 'loading') < 0;
                }
                if (window.HTML_RENDITION.hasRelatedReport){
                    renderComplete = renderComplete && window.HTML_RENDITION.relatedReportRenderComplete;
                }
                if ($('#disclosures .SSBDisclaimer').length > 0) {
                    console.info('Loaded HTML document disclosure');
                    renderComplete = renderComplete && true;
                } else {
                    renderComplete = renderComplete && false;
                }
                if (renderComplete) {
                    console.info('Loaded HTML document ', renderComplete);
                    clearInterval(intervalId);
                    notifyPrint();
                }
                currentWaitInMs += checkDurationInMs;
                if (currentWaitInMs > maxWaitInMs) {
                    clearInterval(intervalId);
                    console.log('Over the loop max waiting time....');
                }
            }, checkDurationInMs);
        }
    }

    public exportStaticHTML() {
        console.log('Start export static HTML');
        const setId = function ($root : any, pre : any){
            if ($root.children().length){
                $root.children().each(function (i : number, el : any){
                    const $el = $(el);
                    const oldId = $el.attr('id');
                    const newId = pre + (i + 1);
                    if (!oldId){
                        $el.attr('id', newId);
                        console.info('Setted id', newId);
                    } else {
                        console.info('It already had id', oldId);
                    }
                    setId($el, newId + '-');
                });
            }
        };
        const notifyPhantom = function (){
            console.log('Page was ready to set id');
            setId($('#root'), 'root-');
            console.log('Setting id is done');
            if (!window.HTML_RENDITION.initialData.includeRHS){
                $('#slider').click();
                $('#rightPaneFloat').remove();
                console.log('Removed RHS');
            }
            console.log('Page was ready to export DOM');
            window.store = commonStore;
            window.state = commonStore.getState();
            if (window.state.presentationStateReducer){
                if (window.state.presentationStateReducer.bodySource){
                    window.state.presentationStateReducer.bodySource = null;
                }
            }
            console.log('Page state', window.state);
            window.HTML_RENDITION.__PRELOADED_STATE__ = JSON.stringify(window.state).replace(/</g,'\\u003c'); // export redux state
            window.HTML_RENDITION.pageReadyToExportDOM = true; // DOM is available to export
        };
        const maxWaitInMs = 200000;
        if (window.HTML_RENDITION.initialData.docFileType == "PPT"){
            const checkDurationInMs = 3 * 1000;
            let currentWaitInMs = 0;
            const intervalId = setInterval(() => {
                const slideCount = commonStore.getState().presentationStateReducer.slideCount;
                let pptSlideRenderComplete = false;
                for (let i = 0; i < slideCount; i++){
                    if ($('#ppt-slideshows .slideContent li[data-number="' + i + '"] #jpedal').length > 0) {
                        console.info('Loaded slide html #', i);
                        pptSlideRenderComplete = true;
                    } else {
                        pptSlideRenderComplete = false;
                    }
                }
                if (pptSlideRenderComplete) {
                    console.info('Loaded all slide html ', pptSlideRenderComplete);
                    clearInterval(intervalId);
                    notifyPhantom();
                }
                currentWaitInMs += checkDurationInMs;
                if (currentWaitInMs > maxWaitInMs) {
                    clearInterval(intervalId);
                    console.log('Over the loop max waiting time....');
                }
            }, checkDurationInMs);
        } else if (window.HTML_RENDITION.isWordRender){
            const checkDurationInMs = 2 * 1000;
            let currentWaitInMs = 0;
            const intervalId = setInterval(() => {
                let wordRenderComplete = window.HTML_RENDITION.wordRenderComplete;
                if ($('#disclosures .SSBDisclaimer').length > 0 || $('.faveDisclosures .SSBDisclaimer').length > 0) {
                    console.info('Loaded MS Word document disclosure');
                    wordRenderComplete = true;
                } else {
                    wordRenderComplete = false;
                }
                if (window.HTML_RENDITION.hasRelatedReport){
                    wordRenderComplete = wordRenderComplete && window.HTML_RENDITION.relatedReportRenderComplete;
                    wordRenderComplete && console.info('Loaded related report');
                }
                if (wordRenderComplete) {
                    console.info('Loaded MS Word document ', wordRenderComplete);
                    clearInterval(intervalId);
                    notifyPhantom();
                }
                currentWaitInMs += checkDurationInMs;
                if (currentWaitInMs > maxWaitInMs) {
                    clearInterval(intervalId);
                    console.log('Over the loop max waiting time....');
                }
            }, checkDurationInMs);
        } else if (window.HTML_RENDITION.isHTMLRender){
            const checkDurationInMs = 1 * 1000;
            let currentWaitInMs = 0;
            const intervalId = setInterval(() => {
                let htmlRenderComplete = window.HTML_RENDITION.htmlRenderComplete;
                if ($('#disclosures .SSBDisclaimer').length > 0) {
                    console.info('Loaded HTML document disclosure');
                    htmlRenderComplete = true;
                } else {
                    htmlRenderComplete = false;
                }
                if (window.HTML_RENDITION.hasRelatedReport){
                    htmlRenderComplete = htmlRenderComplete && window.HTML_RENDITION.relatedReportRenderComplete;
                    htmlRenderComplete && console.info('Loaded related report');
                }
                if (htmlRenderComplete) {
                    console.info('Loaded HTML document ', htmlRenderComplete);
                    clearInterval(intervalId);
                    notifyPhantom();
                }
                currentWaitInMs += checkDurationInMs;
                if (currentWaitInMs > maxWaitInMs) {
                    clearInterval(intervalId);
                    console.log('Over the loop max waiting time....');
                }
            }, checkDurationInMs);
        } else {
            setTimeout(function (){
                console.log('Page was ready to set id');
                setId($('#root'), 'root-');
                console.log('Setting id is done');
                if (!window.HTML_RENDITION.initialData.includeRHS){
                    $('#slider').click();
                }
                setTimeout(function (){
                    if (!window.HTML_RENDITION.initialData.includeRHS){
                        $('#rightPaneFloat').remove();
                        console.log('Removed RHS');
                    }
                    console.log('Page was ready to export DOM');
                    window.store = commonStore;
                    window.state = commonStore.getState();
                    if (window.state.presentationStateReducer){
                        if (window.state.presentationStateReducer.bodySource){
                            window.state.presentationStateReducer.bodySource = null;
                        }
                    }
                    console.log('Page state', window.state);
                    window.HTML_RENDITION.__PRELOADED_STATE__ = JSON.stringify(window.state).replace(/</g,'\\u003c'); // export redux state
                    window.HTML_RENDITION.pageReadyToExportDOM = true; // DOM is available to export
                }, 5000);
            }, 5000);
        }
    }

    public scrollBackToTop() {
        $('html, body').scrollTop(0);
        $('#rsch_banner .header_left_text').trigger('focus');
    }

    public addDetectedClass() {
        const $htmlbody = $('html, body');
        if (window.HTML_RENDITION.authenticationFailed) {
            $htmlbody.hide().addClass('hide');
        }
        if (shouldShowSearch()) {
            $htmlbody.addClass('cv-search');
        }
        if (isAppInsideIFrame()) {
            $htmlbody.addClass('iframe');
        }
        if (deviceInfoService.isIE()) {
            $htmlbody.addClass('ie');
            let ieDocumentMode = deviceInfoService.IEDocumentMode();
            if (!ieDocumentMode) { // For IE10 and IE11
                ieDocumentMode = document.documentMode;
            }
            if (ieDocumentMode) {
                $htmlbody.addClass('ie' + ieDocumentMode);
            }
        }
        if (isTabletOrPhone()) {
            $htmlbody.addClass('device');
        } else {
            $htmlbody.addClass('desktop');
        }
        if (isAndroidTabletOrPhone()) {
            $htmlbody.addClass('android');
        }
        if (isIOSTabletOrPhone()) {
            $htmlbody.addClass('ios');
        }
        if (this.props.initialData.mode == 'preview_mode') {
            $htmlbody.addClass('preview');
        }
        if (window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
                && window.navigator.userAgent.toLowerCase().match(/os\s(\d+)/)
                && window.navigator.userAgent.toLowerCase().match(/os\s(\d+)/)![1] == '9') {
            $('body').addClass('ios9');
        }
        if (isHTMLLightRendition()) {
            $htmlbody.addClass('light_rendition');
        }

        $('body').addClass(this.props.initialData.productType);
        if (window.HTML_RENDITION.initialData.isFAVE && templateCode){
            if (window.HTML_RENDITION.isPoint || window.HTML_RENDITION.isRoundup || templateCode == 'cwnote' || window.HTML_RENDITION.isGlobalizer || templateCode == 'citiexpress'){
                $('body').addClass(templateCode.toLowerCase());
            }
        }
        if (window.HTML_RENDITION.isOffCuffContent && !isStaticHtmlMode()) {
            $('body').addClass('single_post_blog');
        }
        if (window.HTML_RENDITION.isBlogPrintMode) {
            $('html').addClass('print');
        }
        $('body').addClass((this.props.docHeaderJsonData.metadata.isJP) ? 'jp-doc' : 'en-doc');
        if (isStaticHtmlMode()){
            $('body').addClass('slider-collapsed');
        }
        $('html').attr('lang', ((this.props.docHeaderJsonData.metadata.isJP) ? 'ja' : 'en'));
    }

    public addDocTItle(docHeaderJsonData: any, initialData: any, offTheCuffTitle?: string) {
        if (initialData.isNewOutput){
            const productName = window.HTML_RENDITION.initialData.productName;
            let docProductType = docHeaderJsonData.metadata.productType == 'VWPoint' ? 'Viewpoint' : docHeaderJsonData.metadata.productType;
            if (productName && docProductType && (docProductType.toUpperCase() == 'FYI' || docProductType.toUpperCase() == 'BLOG' || window.HTML_RENDITION.initialData.isNonRSCH)){
                docProductType = productName;
            }
            let researchArea = docHeaderJsonData.metadata.researchArea;
            researchArea = !_.isEmpty(researchArea) ? researchArea + ' | ' : '';
            if (offTheCuffTitle) {
                researchArea = offTheCuffTitle + ' | ';
            }
            document.title = docProductType + ' | ' + researchArea + docHeaderJsonData.metadata.tabDate;
        } else {
            document.title = Base64.decode(initialData.doc_headline);
        }
        return document.title;
    }

    public skipToMainContent() {
        console.log('Skip to main content');
        const newhash = docFileType == "HTML" ? '#wp-block-research-title-block-added-by-rendition' : (window.HTML_RENDITION.isPoint || window.HTML_RENDITION.isRoundup || window.HTML_RENDITION.isGlobalizer ? '#issuerPage-titleText' : '#issuerPage-title');
        $(newhash).attr('tabindex', '0').focus();
    }

    public onKeyPressOnSkip(e : any) {
        $(e.currentTarget).css({'height': 'auto', 'color': 'inherit'});
    }

    public onKeyUpOnSkip(e : any) {
        $(e.currentTarget).css('height', '0');
    }

    public showLHS() {
        if (isStaticHtmlMode()) {
            return false;
        }
        if (this.props.initialData.productType === 'blog') {
            return false;
        }
        return true;
    }

    public showHealthWarning() {
        if (_.isEmpty(this.props.docHeaderJsonData)) {
            return false;
        }
        if (isPresentation()) {
            return false;
        }
        if (window.HTML_RENDITION.isOffCuffContent || templateCode === 'citiexpress') {
            return false;
        }
        if (window.HTML_RENDITION.initialData.isGlobalInsights || window.HTML_RENDITION.initialData.isNonRSCHReplay) {
            return false;
        }
        return true;
    }

    public scrollEvent() {
        const _body = $('body');
        const scrollTarget: any = (deviceInfoService.isIE() && HTML_RENDITION.isAppInsideIFrame()) ? _body : $(window);
        let timeout: any = null;
        scrollTarget.on('scroll.whiteBarScroll mousewheel.whiteBarScroll', (e: any) => {
            const top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
            if (top > 5 && !this.props.showOldBranding) {
                this.setState({showLeftFloatPanel: false})
            } else {
                this.setState({showLeftFloatPanel: true})
            }
        })
    }

    public loadOverviewBranding() {
        let Branding: any;
    
        if (this.props.showOldBranding) {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/overviewOld'),
          }, "overviewOld", Date.now());
        }
        else {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/overviewNew'),
          }, "overviewNew", Date.now());
        }
    
        return <Branding/>;
    }

    public loadModalBranding() {
        let Branding: any;
    
        if (this.props.showOldBranding) {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/modalOld'),
          }, "modalOld", Date.now());
        }
        else {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/modalNew'),
          }, "modalNew", Date.now());
        }
    
        return <Branding/>;
    }

    public render() {
        const {docHeaderJsonData, initialData, ifRequireDataGet, RequestSend, analystSubscriptionData} = this.props;
        let isFetching = ifRequireDataGet == 0 && RequestSend ? false : true;
        let docTitle = '';
        if (window.HTML_RENDITION.initialData.isStaticHtml){
            isFetching = false;
        }

        if (this.oneTimeFlag && !isFetching) {
            this.oneTimeFlag = false;
            this.addDetectedClass();
            docTitle = this.addDocTItle(docHeaderJsonData, initialData);     // update browser tab showing title
        }

        if (
            (window.HTML_RENDITION.isBlogPrintMode || window.HTML_RENDITION.isOffCuffList) &&
            this.props.offTheCuffTitle
        ) {
            docTitle = this.addDocTItle(docHeaderJsonData, initialData, this.props.offTheCuffTitle);
        }

        let showBlueBanner = !isFetching && (!window.HTML_RENDITION.isOffCuffContent);
        if (window.HTML_RENDITION.isBlogPrintMode || (window.HTML_RENDITION.isOffCuffContent && (isStaticMode() || isStaticHtmlMode()))){
            showBlueBanner = !isFetching;
        }        
        return (
            <React.Fragment>
                {this.loadOverviewBranding()}
                {this.loadModalBranding()}
                <div id='mainView'>
                    <div className='container'>
                        {
                            isFetching && <Loading />
                        }
                        {this.showHealthWarning() &&
                            (<HealthWarning showOldBranding={this.props.showOldBranding} fpDisc={docHeaderJsonData.fpDisc} />)
                        }
                        {
                            !window.HTML_RENDITION.isOffCuffContent &&
                            <a
                                onFocus={(e) => this.onKeyPressOnSkip(e)}
                                onBlur={(e) => this.onKeyUpOnSkip(e)}
                                className='skip-to-main-content'
                                tabIndex={0}
                                role='button'
                                href='javascript:void(0)'
                                onClick={() => this.skipToMainContent()}
                            >Skip to main content</a>
                        }
                        {showBlueBanner &&
                         (<Header isFetching={isFetching} docTitle={docTitle} showLHS={this.showLHS()} htmlBannerText={initialData.htmlBannerText} showOldBranding={this.props.showOldBranding}/>)
                        }
                        <div id='mainDiv'>
                            <InnerPageContainer showOldBranding={this.props.showOldBranding}/>
                            <div id='mainPage' role='main'>
                                {!isFetching && (
                                    <div id={window.HTML_RENDITION.isOffCuffList ? undefined : 'contentPane'}>
                                        <HtmlPdfToggleBar showPDFDigidocViewer={initialData.showPDFDigidocViewer}/>
                                        <HtmlPdfTogglePanel
                                            container={container}
                                            isJP={this.props.docHeaderJsonData.metadata.isJP}
                                            isOfflineReading={initialData.isEntitled('OFFLINE_READING')}
                                            showPDFDigidocViewer={initialData.showPDFDigidocViewer}
                                            showOldBranding={this.props.showOldBranding}
                                        />
                                    </div>
                                )}
                            </div>
                            {
                                !isFetching && this.state.showLeftFloatPanel &&
                                this.showLHS() && (
                                    <LeftMenuPartTemplate docTitle={docTitle} showOldBranding={this.props.showOldBranding}/>
                                )}
                        </div>
                        {
                            !isFetching &&
                            !window.HTML_RENDITION.isOffCuffContent && templateCode !== 'citiexpress' && !isStaticHtmlMode() && (
                                <div
                                    id='rightPartContain'
                                    role='complementary'
                                    aria-label='info pane'
                                >
                                    <RightPartTemplate showOldBranding={this.props.showOldBranding}/>
                                </div>
                            )
                        }
                        {
                            !isFetching &&
                            !window.HTML_RENDITION.isOffCuffContent && !isStaticHtmlMode() && (
                                <div
                                    id='back-to-top'
                                    tabIndex={0}
                                    role='button'
                                    aria-label='Back to top'
                                    style={{ display: 'none' }}
                                    onClick={() => this.scrollBackToTop()}
                                    onKeyPress={(e) =>
                                        enterKeyPressed(
                                            e,
                                            this.scrollBackToTop.bind(this)
                                        )
                                    }
                                >
                                </div>
                            )}
                        {!isFetching &&  <MainPageCopyText />}

                        {!isFetching && window.HTML_RENDITION.isBlogPrintMode &&  <div className='blog-watermark-container'>{window.HTML_RENDITION.initialData.watermarkText}</div>}
                    </div>
                </div>
                <div id='globalLoadingMask' style={{ display: 'none' }}>
                    <Loading
                        showLoadingBackground={true}
                        overrideStyle={{ position: 'fixed' }}
                    />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        ifRequireDataGet: state.asyncStateReducer.ifRequireDataGet,
        RequestSend: state.asyncStateReducer.RequestSend,
        docFooterJsonData: state.asyncStateReducer.docFooterJsonData,
        offTheCuffTitle: state.commonStateReducer.offTheCuffTitle,
        analystSubscriptionData: state.asyncStateReducer.analystSubscriptionData,
        menuCode: state.commonStateReducer.menuCode,
        platformIdData: state.asyncStateReducer.platformIdData,
        excludeCopyFigurePlatformIdData: state.asyncStateReducer.excludeCopyFigurePlatformIdData,
    };
};

const mapDispatchToProps = (dispatch: (any)) => ({
    loadInitialData: () => dispatch(asyncStateAction.fetchData()),
    loadHeaderJsonData: () => dispatch(asyncStateAction.fetchHeaderData(servicesConfig.GET_HEADER_JSON_DATA)),
    sessionContextData: () => dispatch(asyncStateAction.fetchSessionContextData(servicesConfig.GET_SESSION_CONTEXT_DATA)),
    loadPlatformIdData: () => dispatch(asyncStateAction.fetchPlatformIdData(servicesConfig.GET_PLATFORM_ID_DATA)),
    loadExcludeCopyFigurePlatformIdData: () => dispatch(asyncStateAction.fetchExcludeCopyFigurePlatformIdData(servicesConfig.GET_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA)),
    loadBodyJsonData: () => dispatch(asyncStateAction.fetchBodyData(servicesConfig.GET_BODY_JSON_DATA)),
    loadFooterJsonData: () => dispatch(asyncStateAction.fetchFooterData(servicesConfig.GET_FOOTER_JSON_DATA)),
    getScreenType: () => dispatch(commonStateAction.getScreenType()),
    getMenuCode: () => dispatch(commonStateAction.getMenuCode()),
    loadFigureGalleryData: () => dispatch(asyncStateAction.fetchFigureGallery(environmentService.getJsonPath(servicesConfig.GET_FIGURE_GALLERY))),
    loadAnalystSubscriptionData: () => dispatch(asyncStateAction.fetchAnalystSubscriptionData(servicesConfig.GET_ANALYST_DIRECTORY_DATA)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OverviewContainer);
